export const LANGUAGES = {
  EN: 'en',
  MK: 'mk',
  SQ: 'sq',
}
